import { Box, Table } from '@flos/react-ui';
import { useHippoText } from '../../../../hooks/useHippoText';
import { useRecoilValue } from 'recoil';
import { opcInfoAtom } from '../../../../recoil/atoms/opcInfoAtom';
import { FLAVOUR_NAME_MAP } from '../../../../constants/coverable';
import type { AttributeChangeInformationProps } from '../../types';
import useWindowSize from '../../../../hooks/useWindowSize';

const AttributeChangeInformation = ({
    attributeChangeProps
}: {
    attributeChangeProps: AttributeChangeInformationProps;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const { productName } = useRecoilValue(opcInfoAtom);
    const { isMobileDevice } = useWindowSize();
    const { title, mobileProps, desktopProps, detailPriceText } = attributeChangeProps;

    return (
        <>
            <h6>
                {title ??
                    getHippoText(detailPriceText, {
                        flavor: FLAVOUR_NAME_MAP[productName]
                    })}
            </h6>
            {isMobileDevice ? (
                <>
                    <div className="u-spacing-stack-m">
                        <Box title={getHippoText(mobileProps.before.price.label)}>
                            <p>{mobileProps.before.price.value}</p>
                        </Box>
                        <Box title={getHippoText(mobileProps.before.attribute.label)}>
                            {mobileProps.before.attribute.value}
                        </Box>
                    </div>
                    <div>
                        <Box title={getHippoText(mobileProps.after.price.label)}>
                            <p>{mobileProps.after.price.value}</p>
                        </Box>
                        <Box title={getHippoText(mobileProps.after.attribute.label)}>
                            {mobileProps.after.attribute.value}
                        </Box>
                    </div>
                </>
            ) : (
                <Table mobileDirection="vertical" className="u-spacing-stack-sm" wrapped={true}>
                    <Table.Head>
                        <Table.Row>
                            <Table.HeadCell id={'table-head-before'}>
                                {getHippoText(desktopProps.before.priceLable)}
                            </Table.HeadCell>
                            <Table.HeadCell id={'table-head-after'}>
                                {getHippoText(desktopProps.after.priceLable)}
                            </Table.HeadCell>
                        </Table.Row>
                    </Table.Head>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell data-header={desktopProps.before.priceLable} scope="row">
                                {desktopProps.before.priceValue}
                            </Table.Cell>
                            <Table.Cell data-header={desktopProps.after.priceLable} scope="row">
                                {desktopProps.after.priceValue}
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell data-header={desktopProps.before.priceLable} scope="row">
                                {desktopProps.before.attributeValue}
                            </Table.Cell>
                            <Table.Cell data-header={desktopProps.after.priceLable} scope="row">
                                {desktopProps.after.attributeValue}
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            )}
        </>
    );
};

export default AttributeChangeInformation;
